import { useState, useEffect } from "react";
import {
  getAllCrewUser,
  getProjectTask,
  getUserDetails,
  getCrewEquipmentList,
  getAllProjectList,
} from "../API";
import { toast } from "react-toastify";
function useFetch(addCrewModal, crew_id, project_id, entryType) {
  const [crewUsers, setCrewUsers] = useState([]);
  const [crewEquipments, setCrewEquipments] = useState([]);
  const [projectTaskOptions, setProjectTaskOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  // const [otherEntries, setOtherEntries] = useState([]);
  const [teamMemberLoading, setTeamMemberLoading] = useState(false);
  const [equipmentLoading, setEquipmentLoading] = useState(false);

  useEffect(() => {
    if (addCrewModal && entryType === "user") {
      if (crew_id) {
        onClickAddCrewTimeDate();
        // getAllCostCodes();
        fetchAllProjects();
        // fetchEquipmentList();
      }
      if (project_id) {
        getAllProjectTasks();
      }
    } else if (addCrewModal && entryType === "equipment") {
      if (crew_id) {
        // onClickAddCrewTimeDate();
        // getAllCostCodes();
        fetchEquipmentList();
        fetchAllProjects();
      }
      if (project_id) {
        getAllProjectTasks();
      }
    } else if (addCrewModal && entryType === "both") {
      if (crew_id) {
        onClickAddCrewTimeDate();
        // getAllCostCodes();
        fetchAllProjects();
        fetchEquipmentList();
      }
      if (project_id) {
        getAllProjectTasks();
      }
    }
  }, [addCrewModal, entryType, crew_id, project_id]);

  const fetchEquipmentList = async () => {
    setEquipmentLoading(true);
    try {
      const equipmentList = await getCrewEquipmentList(crew_id);

      if (equipmentList?.data?.length > 0) {
        const uniqueAcumaticaIds = new Set();
        const permanentEquipments = equipmentList?.data?.filter(
          (equipment) => equipment?.type === "permanent"
        );
        const listOptions = permanentEquipments
          ?.filter((item) => {
            const acumatica_id = item?.equipment?.acumatica_id || "NA";
            if (!uniqueAcumaticaIds.has(acumatica_id) && item?.equipment) {
              uniqueAcumaticaIds.add(acumatica_id);
              return true;
            }
            return false;
          })
          .map((ele) => {
            return {
            label: `(${ele?.equipment?.acumatica_id || "NA"}) ${
              ele?.equipment?.name
            }`,
            value: ele,
          }});
        setCrewEquipments(listOptions);
        setEquipmentLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong.");
      setEquipmentLoading(false);
    } finally {
      setEquipmentLoading(false);
    }
  };

  const fetchAllProjects = async () => {
    await getAllProjectList().then((res) => {
      const projectDropDownOptions = res?.data?.map((item) => {
        return {
          label: `(${item?.acumatica_project_id}) ${item?.description}`,
          value: item,
        };
      });
      setProjectOptions(projectDropDownOptions);
    });
  };

  const onClickAddCrewTimeDate = async () => {
    setTeamMemberLoading(true);
    await getUserDetails()
      .then(async (res) => {
        // setAllUsers(res?.data);
        const userData = res?.data.slice();
        await getAllCrewUser(crew_id)
          .then((res) => {
            if (res?.status === 200) {
              const crewMemberUsers = res?.data?.filter(
                (item) =>
                  (item?.crew_role_id === 4 ||
                    item?.crew_role_id === 1 ||
                    item?.crew_role_id === 5) &&
                  item?.type === "permanent"
              );
              const filteredCrewUsers = crewMemberUsers
                ?.map((ele) => {
                  const matchingUser = userData?.find((crewEle) => {
                    return crewEle?.id === ele?.user_id;
                  });
                  if (matchingUser) {
                    matchingUser.crew_user_id = ele?.id;
                    return { label: matchingUser?.name, value: matchingUser };
                  }
                  return undefined;
                })
                .filter(Boolean)
                .sort((a, b) => {
                  const nameA = a.label.toUpperCase();
                  const nameB = b.label.toUpperCase();
                  if (nameA < nameB) {
                    return -1;
                  }
                  if (nameA > nameB) {
                    return 1;
                  }
                  return 0;
                });
              setCrewUsers(filteredCrewUsers);
            }
            setTeamMemberLoading(false);
          })
          .catch((err) => {
            console.log("Error Occured in AddCrewTimeDateModal", err);
            setTeamMemberLoading(false);
          });
      })
      .catch((err) =>
        console.log("error occured in AddCrewTimeDateModal", err)
      );
  };
  const getAllProjectTasks = async () => {
    await getProjectTask(project_id).then((res) => {
      if (res?.status === 200) {
        const dropDownOptions = res?.data?.map((ele) => {
          return { label: ele?.description, value: ele };
        });
        setProjectTaskOptions(dropDownOptions);
      }
    });
  };
  return {
    projectTaskOptions,
    crewUsers,
    crewEquipments,
    // costCodesOptions,
    projectOptions,
    onClickAddCrewTimeDate,
    fetchEquipmentList,
    teamMemberLoading,
    equipmentLoading,
    setEquipmentLoading,
  };
}

export default useFetch;
